import Firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'

import { seedDatabase } from '../seed';

const config = {
   apiKey: "AIzaSyAwzeObQmvq4dUppn3I9Xq6b4Io-t1V3xo",
   authDomain: "netflix-b8e22.firebaseapp.com",
   databaseURL: "https://netflix-b8e22-default-rtdb.europe-west1.firebasedatabase.app",
   projectId: "netflix-b8e22",
   storageBucket: "netflix-b8e22.appspot.com",
   messagingSenderId: "171668524427",
   appId: "1:171668524427:web:83a4aaee94cc706b31b38e",
   measurementId: "G-0YG1CS9P2L"
}; 

const firebase = Firebase.initializeApp(config);

// seedDatabase(firebase);

export { firebase };